<div class="content-wrapper">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <section class="users-list-wrapper">
            <div class="col-12 printRef">
                <div class="card invoice-preview-card">
                    <div class="card-body invoice-padding pb-0">
                        <form [formGroup]="form" (ngSubmit)="onSubmit()">
                            <div class="form-group col-md-12">
                                <label class="form-label" for="title">Başlık</label>
                                <input formControlName="title" type="text" id="title" class="form-control"
                                    placeholder="Başlık giriniz" />
                            </div>

                            <div class="form-group col-md-12">
                                <quill-editor formControlName="description">
                                    <div quill-editor-toolbar>
                                        <span class="ql-formats">
                                            <button class="ql-bold" [title]="'Bold'"></button>
                                            <button class="ql-italic" [title]="'italic'"></button>
                                            <button class="ql-underline" [title]="'underline'"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <select class="ql-align" [title]="'Alignment'">
                                                <option selected></option>
                                                <option value="center"></option>
                                                <option value="right"></option>
                                                <option value="justify"></option>
                                            </select>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-list" value="ordered" type="button"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-link" value="ordered" type="button"></button>
                                        </span>
                                    </div>
                                </quill-editor>
                            </div>

                            <!-- Kaydet Butonu -->
                            <div class="form-group col-md-12">
                                <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Kaydet</button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
